/**
 * Custom Addon - Gestion de l'ajout au panier
 * Version 2.1 - Compatible thème Prestige + Bundle Total
 */

(function() {
  'use strict';

  const CustomAddon = {
    selectors: {
      checkbox: '.custom-addon-checkbox',
      variantSelect: '.custom-addon-card__variant-select',
      addonCard: '.custom-addon-card',
      addonSection: '[data-addon-section]',
      addToCartButton: '[data-action="add-to-cart"], .product-form__add-button, button[name="add"], [type="submit"][name="add"], .ProductForm__AddToCart, .product__submit__add',
      priceWrapper: '[data-price-wrapper]',
      discountedPrice: '[data-addon-price]',
      originalPrice: '[data-addon-compare]',
      savingsBadge: '[data-savings-badge]',
      bundleTotal: '[data-bundle-total]',
      bundlePrice: '[data-bundle-price]',
      bundleCompare: '[data-bundle-compare]',
      bundleSavings: '[data-bundle-savings]'
    },

    pendingAddon: null,

    init() {
      this.bindEvents();
      this.initAddonCards();
      this.listenToCartEvents();
      this.listenToMainVariantChange();
    },

    bindEvents() {
      // Gestion du changement de checkbox
      document.querySelectorAll(this.selectors.checkbox).forEach(checkbox => {
        checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      });

      // Gestion du changement de variante
      document.querySelectorAll(this.selectors.variantSelect).forEach(select => {
        select.addEventListener('change', this.handleVariantChange.bind(this));
      });

      // Intercepter le clic sur le bouton Add to Cart
      this.interceptAddToCartClick();
    },

    initAddonCards() {
      document.querySelectorAll(this.selectors.checkbox).forEach(checkbox => {
        const card = checkbox.closest(this.selectors.addonCard);
        if (card) {
          card.classList.toggle('is-selected', checkbox.checked);
        }
        // Mettre à jour le total bundle initial
        this.updateBundleTotal(checkbox);
      });
    },

    handleCheckboxChange(event) {
      const checkbox = event.target;
      const card = checkbox.closest(this.selectors.addonCard);
      
      if (card) {
        card.classList.toggle('is-selected', checkbox.checked);
      }

      const select = card?.querySelector(this.selectors.variantSelect);
      if (select && checkbox.checked) {
        checkbox.value = select.value;
        checkbox.dataset.addonId = select.value;
      }

      // Afficher/masquer le total bundle
      this.updateBundleTotal(checkbox);
    },

    handleVariantChange(event) {
      event.stopPropagation();
      
      const select = event.target;
      const card = select.closest(this.selectors.addonCard);
      const section = select.closest(this.selectors.addonSection);
      const checkbox = card?.querySelector(this.selectors.checkbox);
      const blockId = select.dataset.blockId;
      const selectedOption = select.options[select.selectedIndex];
      
      if (checkbox) {
        checkbox.value = select.value;
        checkbox.dataset.addonId = select.value;
        checkbox.dataset.price = selectedOption.dataset.finalPrice;
        checkbox.dataset.comparePrice = selectedOption.dataset.strikePrice;
        card.dataset.addonId = select.value;
      }

      // Mettre à jour les prix affichés
      const priceWrapper = card?.querySelector(`[data-price-wrapper="${blockId}"]`);
      if (priceWrapper) {
        const finalPrice = parseInt(selectedOption.dataset.finalPrice, 10);
        const strikePrice = selectedOption.dataset.strikePrice;
        const savings = parseInt(selectedOption.dataset.savings, 10) || 0;
        
        const discountedPriceEl = priceWrapper.querySelector(this.selectors.discountedPrice);
        const originalPriceEl = priceWrapper.querySelector(this.selectors.originalPrice);
        
        if (discountedPriceEl) {
          discountedPriceEl.textContent = this.formatMoney(finalPrice);
        }
        
        if (originalPriceEl) {
          if (strikePrice && strikePrice !== '' && parseInt(strikePrice, 10) > finalPrice) {
            originalPriceEl.textContent = this.formatMoney(parseInt(strikePrice, 10));
            originalPriceEl.style.display = '';
          } else {
            originalPriceEl.style.display = 'none';
          }
        }

        // Mettre à jour le badge Save (sur la section)
        const section = card?.closest(this.selectors.addonSection);
        const savingsBadge = section?.querySelector(this.selectors.savingsBadge);
        const showSavingsBadge = section?.dataset.showSavingsBadge !== 'false';
        if (savingsBadge) {
          if (savings > 0 && showSavingsBadge) {
            savingsBadge.textContent = 'Save ' + this.formatMoney(savings);
            savingsBadge.style.display = '';
          } else {
            savingsBadge.style.display = 'none';
          }
        }
      }

      // Mettre à jour le total bundle
      if (checkbox) {
        this.updateBundleTotal(checkbox);
      }
    },

    updateBundleTotal(checkbox) {
      const section = checkbox.closest(this.selectors.addonSection);
      if (!section) return;

      const bundleTotal = section.querySelector(this.selectors.bundleTotal);
      if (!bundleTotal) return;

      const showBundleTotal = section.dataset.showBundleTotal === 'true';
      if (!showBundleTotal) {
        bundleTotal.style.display = 'none';
        return;
      }

      if (checkbox.checked) {
        // Récupérer les prix
        const mainPrice = parseInt(section.dataset.mainPrice, 10) || 0;
        const mainCompare = parseInt(section.dataset.mainCompare, 10) || mainPrice;
        const addonPrice = parseInt(checkbox.dataset.price, 10) || 0;
        const addonCompare = parseInt(checkbox.dataset.comparePrice, 10) || addonPrice;

        const total = mainPrice + addonPrice;
        const compareTotal = mainCompare + addonCompare;
        const savings = compareTotal - total;

        // Mettre à jour les éléments
        const bundlePriceEl = bundleTotal.querySelector(this.selectors.bundlePrice);
        const bundleCompareEl = bundleTotal.querySelector(this.selectors.bundleCompare);
        const bundleSavingsEl = bundleTotal.querySelector(this.selectors.bundleSavings);

        if (bundlePriceEl) {
          bundlePriceEl.textContent = this.formatMoney(total);
        }

        if (bundleCompareEl) {
          if (savings > 0) {
            bundleCompareEl.textContent = this.formatMoney(compareTotal);
            bundleCompareEl.style.display = '';
          } else {
            bundleCompareEl.style.display = 'none';
          }
        }

        if (bundleSavingsEl) {
          if (savings > 0) {
            bundleSavingsEl.textContent = 'You save ' + this.formatMoney(savings);
            bundleSavingsEl.parentElement.style.display = '';
          } else {
            bundleSavingsEl.parentElement.style.display = 'none';
          }
        }

        bundleTotal.style.display = 'block';
      } else {
        bundleTotal.style.display = 'none';
      }
    },

    listenToMainVariantChange() {
      // Écouter les changements de variante du produit principal
      document.addEventListener('variant:changed', (event) => {
        const variant = event.detail?.variant;
        if (variant) {
          this.updateMainProductPrice(variant.price, variant.compare_at_price || variant.price);
        }
      });

      // Observer les changements de prix dans le DOM (fallback)
      const priceObserver = new MutationObserver(() => {
        // Récupérer le prix actuel du produit principal depuis le DOM
        const mainPriceEl = document.querySelector('[data-product-price]');
        if (mainPriceEl) {
          const price = parseInt(mainPriceEl.dataset.productPrice, 10);
          if (price) {
            document.querySelectorAll(this.selectors.addonSection).forEach(section => {
              section.dataset.mainPrice = price;
            });
          }
        }
      });

      const priceContainer = document.querySelector('.product-meta__price');
      if (priceContainer) {
        priceObserver.observe(priceContainer, { childList: true, subtree: true });
      }
    },

    updateMainProductPrice(price, comparePrice) {
      document.querySelectorAll(this.selectors.addonSection).forEach(section => {
        section.dataset.mainPrice = price;
        section.dataset.mainCompare = comparePrice;
        
        // Mettre à jour le total bundle si une checkbox est cochée
        const checkbox = section.querySelector(this.selectors.checkbox);
        if (checkbox && checkbox.checked) {
          this.updateBundleTotal(checkbox);
        }
      });
    },

    interceptAddToCartClick() {
      document.addEventListener('click', (event) => {
        const button = event.target.closest(this.selectors.addToCartButton);
        
        if (button) {
          const checkedAddons = this.getCheckedAddons();
          
          if (checkedAddons.length > 0) {
            this.pendingAddon = checkedAddons[0];
          }
        }
      }, true);

      this.interceptFetch();
    },

    interceptFetch() {
      const originalFetch = window.fetch;
      const self = this;

      window.fetch = async function(...args) {
        const [url] = args;
        const urlString = typeof url === 'string' ? url : url?.url || '';
        
        const response = await originalFetch.apply(this, args);
        
        if (urlString.includes('/cart/add') && self.pendingAddon) {
          setTimeout(async () => {
            await self.addAddonToCart();
          }, 300);
        }
        
        return response;
      };
    },

    listenToCartEvents() {
      const cartEvents = [
        'cart:add',
        'cart:added', 
        'theme:cart:change',
        'product:added',
        'ajaxCart:itemAdded'
      ];
      
      cartEvents.forEach(eventName => {
        document.addEventListener(eventName, () => {
          if (this.pendingAddon) {
            this.addAddonToCart();
          }
        });
      });
    },

    getCheckedAddons() {
      const addons = [];
      const checkedBoxes = document.querySelectorAll(`${this.selectors.checkbox}:checked`);
      
      checkedBoxes.forEach(checkbox => {
        const card = checkbox.closest(this.selectors.addonCard);
        const select = card?.querySelector(this.selectors.variantSelect);
        
        const variantId = select ? select.value : checkbox.value;
        
        if (variantId) {
          addons.push({
            id: parseInt(variantId, 10),
            quantity: 1
          });
        }
      });
      
      return addons;
    },

    async addAddonToCart() {
      if (!this.pendingAddon) return;

      const addon = this.pendingAddon;
      this.pendingAddon = null;

      try {
        const payload = {
          items: [{
            id: addon.id,
            quantity: addon.quantity,
            properties: {
              '_addon': 'true'
            }
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erreur ajout addon');
        }

        this.refreshCart();

      } catch (error) {
        console.error('[CustomAddon] Erreur:', error);
      }
    },

    refreshCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:cart:change'));
      
      const cartDrawer = document.querySelector('[data-section-type="cart-drawer"], .cart-drawer, .mini-cart');
      if (cartDrawer) {
        fetch('/cart?view=drawer').catch(() => {});
      }

      if (window.location.pathname === '/cart') {
        window.location.reload();
      }

      this.refreshCartCount();
    },

    async refreshCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-item-count, .Header__CartCount').forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch (error) {
        // Silently fail
      }
    },

    formatMoney(cents) {
      // Utiliser le format Shopify si disponible
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        // Shopify.formatMoney attend le format de devise du thème
        const moneyFormat = window.theme?.moneyFormat || window.Shopify?.money_format || '${{amount}}';
        return Shopify.formatMoney(cents, moneyFormat);
      }
      
      // Fallback : format simple
      const amount = (cents / 100).toFixed(2);
      const currency = window.Shopify?.currency?.active || 'USD';
      
      // Format avec symbole de devise
      try {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (e) {
        return `$${amount}`;
      }
    }
  };

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => CustomAddon.init());
  } else {
    CustomAddon.init();
  }

  window.CustomAddon = CustomAddon;
})();
